/*
 * CarCreatorConstants
 */

export const UPDATE_DATA = 'ideal/CarCreator/UPDATE_DATA';
export const SAVE_DATA = 'ideal/CarCreator/SAVE_DATA';
export const SAVE_SUCCESS_RESPONSE = 'ideal/CarCreator/SAVE_SUCCESS_RESPONSE';
export const SAVE_ERROR_RESPONSE = 'ideal/CarCreator/SAVE_ERROR_RESPONSE';
export const CLEAR_DATA = 'ideal/CarCreator/CLEAR_DATA';

export const CAR_CATEGORIES = [
  {
    description: 'City Car',
    value: 'city-car',
  },
  {
    description: 'Berlina',
    value: 'berlina',
  },
  {
    description: 'Sportiva/Coupe',
    value: 'sportiva-coupe',
  },
  {
    description: 'SUV/Crossover',
    value: 'suv-crossover',
  },
  {
    description: 'Monovolume',
    value: 'monovolume',
  },
  {
    description: 'Station Wagon',
    value: 'station-wagon',
  },
  {
    description: 'Veicoli Commerciali',
    value: 'veicoli-commerciali',
  },
  {
    description: 'Minicar',
    value: 'minicar',
  },
  {
    description: 'Autocarro',
    value: 'autocarro',
  },
];

export const CAR_FUELS = [
  {
    description: 'Benzina',
    value: 'benzina',
  },
  {
    description: 'Diesel',
    value: 'diesel',
  },
  {
    description: 'GPL',
    value: 'gpl',
  },
  {
    description: 'Metano',
    value: 'metano',
  },
  {
    description: 'Elettrica',
    value: 'elettrica',
  },
  {
    description: 'full-hybrid-benzina',
    value: 'HEV-IB',
  },
  {
    description: 'full-hybrid-diesel',
    value: 'HEV-ID',
  },
  {
    description: 'full-hybrid-benzina',
    value: 'FHEV-IB',
  },
  {
    description: 'full-hybrid-diesel',
    value: 'FHEV-ID',
  },
  {
    description: 'mild-hybrid-benzina',
    value: 'MHEV-IB',
  },
  {
    description: 'mild-hybrid-diesel',
    value: 'MHEV-ID',
  },
  {
    description: 'plug-in-hybrid-benzina',
    value: 'PEV-IB',
  },
  {
    description: 'plug-in-hybrid-diesel',
    value: 'PHEV-ID',
  },
];

export const CAR_SEGMENTS = [
  {
    description: 'A',
    value: 'A',
  },
  {
    description: 'B',
    value: 'B',
  },
  {
    description: 'C',
    value: 'C',
  },
  {
    description: 'D',
    value: 'D',
  },
  {
    description: 'E',
    value: 'E',
  },
];

export const CAR_GEARS = [
  {
    description: 'Manuale',
    value: 'manuale',
  },
  {
    description: 'Automatico',
    value: 'automatico',
  },
  {
    description: 'Automatico CVT',
    value: 'automatico-cvt',
  },
  {
    description: 'Automatico sequenziale',
    value: 'automatico-sequenziale',
  },
  {
    description: 'Automatico doppia Frizione',
    value: 'automatico-doppia-frizione',
  },
];
